<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="年份">
        <el-date-picker v-model="yearPicker" type="year" placeholder="选择年份" size="small" value-format="yyyy" style="width:140px" clearable />
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('base:holidayDate:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button size="small" @click="reset">重置</el-button>
        <el-button v-if="isAuth('base:holidayDate:save')" type="primary" size="small" @click="openBatch">批量新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="holidayDate" label="节假日日期" width="120" align="center" />
      <el-table-column prop="year" label="年份" width="90" align="center" />
      <el-table-column prop="month" label="月份" width="90" align="center" />
      <el-table-column prop="day" label="日期" width="90" align="center" />
      <el-table-column prop="createDate" label="创建日期" min-width="120" align="center">
        <template slot-scope="scope">{{ (scope.row.createDate || '').substr(0, 10) }}</template>
      </el-table-column>
      <el-table-column v-if="isAuth('base:holidayDate:delete')" label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1; load() }" @current-change="p => { pageIndex = p; load() }" />

    <el-dialog title="批量新增节假日" :visible.sync="batchVisible" width="520px" :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item label="节假日日期">
          <el-date-picker v-model="selectedDates" type="dates" placeholder="请选择多个日期" value-format="yyyy-MM-dd" style="width:100%" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="batchVisible = false">取消</el-button>
        <el-button type="primary" @click="saveBatch">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'HolidayDate',
  data() {
    return {
      yearPicker: '', list: [], pageIndex: 1, pageSize: 20, total: 0, loading: false,
      batchVisible: false, selectedDates: [], permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' }
    }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    search() { this.pageIndex = 1; this.load() },
    reset() { this.yearPicker = ''; this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      const body = { currentPage: this.pageIndex, pageSize: this.pageSize }
      if (this.yearPicker) body.year = Number(this.yearPicker)
      request.post('/base/holidayDate/list', body).then(res => {
        const data = res.data || {}
        this.list = data.list || []
        this.total = data.totalCount || 0
      }).catch(() => { this.list = []; this.total = 0 }).finally(() => { this.loading = false })
    },
    openBatch() { this.batchVisible = true; this.selectedDates = [] },
    saveBatch() {
      if (!this.selectedDates || !this.selectedDates.length) {
        this.$message.warning('请选择至少一个日期')
        return
      }
      request.post('/base/holidayDate/save', { holidayDate: this.selectedDates }).then(() => {
        this.$message.success('保存成功')
        this.batchVisible = false
        this.load()
      }).catch(() => {})
    },
    remove(row) {
      this.$confirm('确定删除该节假日?', '提示', { type: 'warning' }).then(() => {
        request.post('/base/holidayDate/delete', { holidayDateId: row.holidayDateId }).then(() => {
          this.$message.success('删除成功')
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
</style>
